/**
 * Update nudge rules (Paul, Oct 28 2026): a machine 10 or more Connector versions behind the
 * version it is offered sees the plain "A newer Maestro is ready — Update" banner. The banner
 * opens the existing installer download; it never touches playback. A dismissal holds for
 * 3 days per installed version (localStorage), so the nudge returns but never nags.
 */
export const NUDGE_BEHIND_VERSIONS = 10;
export const NUDGE_DISMISSED_KEY = 'maestro_update_nudge_dismissed';
export const NUDGE_SNOOZE_MS = 3 * 86_400_000;

type V = { major: number; minor: number; patch: number } | null;

export function versionsBehind(current: V, latest: V): number {
  if (!current || !latest) return 0;
  if (current.major !== latest.major || current.minor !== latest.minor) {
    return latest.major > current.major || (latest.major === current.major && latest.minor > current.minor) ? Number.POSITIVE_INFINITY : 0;
  }
  return Math.max(0, latest.patch - current.patch);
}

export function isFarBehind(current: V, latest: V): boolean {
  return versionsBehind(current, latest) >= NUDGE_BEHIND_VERSIONS;
}

export function nudgeDismissedRecently(installed: string | null, now = Date.now()): boolean {
  try {
    const raw = localStorage.getItem(NUDGE_DISMISSED_KEY);
    if (!raw) return false;
    const d = JSON.parse(raw) as { v?: string; at?: number };
    return d.v === (installed || '') && typeof d.at === 'number' && now - d.at < NUDGE_SNOOZE_MS;
  } catch {
    return false;
  }
}

export function rememberNudgeDismissed(installed: string | null, now = Date.now()): void {
  try { localStorage.setItem(NUDGE_DISMISSED_KEY, JSON.stringify({ v: installed || '', at: now })); } catch { /* ignore */ }
}
